import { Routes, Route, Navigate } from "react-router";
import AppLayout from "./layouts/AppLayout";
import SettingsLayout from "./layouts/SettingsLayout";
import RequireMonitoring from "./layouts/RequireMonitoring";
import RequireAccountType from "./layouts/RequireAccountType";
import RequireActivePlan from "./layouts/RequireActivePlan";

import DashboardPage from "./pages/dashboard/DashboardPage";
import ScreeningPage from "./pages/screening/ScreeningPage";
import BatchPage from "./pages/batch/BatchPage";
import BatchDetailPage from "./pages/batch/BatchDetailPage";
import BatchSearchMatchesPage from "./pages/batch/BatchSearchMatchesPage";
import MonitoringPage from "./pages/monitoring/MonitoringPage";
import MonitoringNewPage from "./pages/monitoring/MonitoringNewPage";
import MonitoringEntryPage from "./pages/monitoring/MonitoringEntryPage";
import AccountManagementPage from "./pages/settings/AccountManagementPage";
import ApiSettingsPage from "./pages/settings/ApiSettingsPage";
import CompanySettingsPage from "./pages/settings/CompanySettingsPage";
import HelpPage from "./pages/help/HelpPage";
import DpaDisclaimerPage from "./pages/legal/DpaDisclaimerPage";
import MatchDetailIndexPage from "./pages/preview/MatchDetailIndexPage";
import MatchDetailVariantPage from "./pages/preview/MatchDetailVariantPage";
import DashboardStatesPage from "./pages/preview/DashboardStatesPage";
import DesignPage from "./pages/design/DesignPage";
import LoginPage from "./pages/auth/LoginPage";
import SignupPage from "./pages/auth/SignupPage";
import WelcomeDashboardPage from "./pages/auth/WelcomeDashboardPage";
import ForgotPasswordPage from "./pages/auth/ForgotPasswordPage";
import ResetPasswordPage from "./pages/auth/ResetPasswordPage";
import NotFoundPage from "./pages/_errors/NotFoundPage";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<AppLayout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route element={<RequireAccountType navKey="dashboard" />}>
          <Route element={<RequireActivePlan />}>
            <Route path="dashboard" element={<DashboardPage />} />
          </Route>
        </Route>
        <Route element={<RequireAccountType navKey="screening" />}>
          <Route element={<RequireActivePlan />}>
            <Route path="screening-portal" element={<ScreeningPage />} />
          </Route>
        </Route>
        <Route element={<RequireAccountType navKey="batch" />}>
          <Route element={<RequireActivePlan />}>
            <Route path="batch" element={<BatchPage />} />
            <Route path="batch/:batchId" element={<BatchDetailPage />} />
            <Route path="batch/:batchId/search/:searchId" element={<BatchSearchMatchesPage />} />
          </Route>
        </Route>
        <Route element={<RequireAccountType navKey="monitoring" />}>
          <Route element={<RequireActivePlan />}>
            <Route element={<RequireMonitoring />}>
              <Route path="monitoring-portal" element={<MonitoringPage />} />
              <Route path="monitoring-portal/new" element={<MonitoringNewPage />} />
              <Route path="monitoring-portal/:entryId" element={<MonitoringEntryPage />} />
            </Route>
          </Route>
        </Route>
        <Route path="help" element={<HelpPage />} />
        <Route path="data-processing-agreement" element={<DpaDisclaimerPage />} />
        <Route path="preview/match-detail" element={<MatchDetailIndexPage />} />
        <Route path="preview/match-detail/:variant" element={<MatchDetailVariantPage />} />
        <Route path="preview/dashboard" element={<DashboardStatesPage />} />
        <Route path="design" element={<DesignPage />} />
        <Route element={<RequireAccountType navKey="settings" />}>
          <Route path="settings" element={<Navigate to="/account-management" replace />} />
          <Route element={<RequireActivePlan />}>
            <Route element={<SettingsLayout />}>
              <Route path="account-management" element={<AccountManagementPage />} />
              <Route element={<RequireAccountType navKey="apiSettings" />}>
                <Route path="api-settings" element={<ApiSettingsPage />} />
              </Route>
              <Route path="company-settings" element={<CompanySettingsPage />} />
            </Route>
          </Route>
        </Route>
        <Route path="login" element={<LoginPage />} />
        <Route path="signup" element={<SignupPage />} />
        <Route path="verify-otp" element={<Navigate to="/login" replace />} />
        <Route path="signup/password" element={<Navigate to="/signup" replace />} />
        <Route path="welcomedashboard" element={<WelcomeDashboardPage />} />
        <Route path="forgot-password" element={<ForgotPasswordPage />} />
        <Route path="reset-password" element={<ResetPasswordPage />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
